"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var ui_1 = require("../../../ui");
var reducer_1 = __importDefault(require("./reducer"));
var state_1 = __importDefault(require("./state"));
var Types = __importStar(require("./type"));
var WithLoader = function (props) {
    var _a = react_1.useReducer(reducer_1["default"], state_1["default"]()), state = _a[0], dispatch = _a[1];
    var data = state.data, error = state.error, loading = state.loading;
    var Component = props.Component, dataLoad = props.dataLoad, _b = props.noDataMessage, noDataMessage = _b === void 0 ? 'No data.' : _b, NoDataComponent = props.NoDataComponent, LoaderWrapperComponent = props.LoaderWrapperComponent, rest = __rest(props, ["Component", "dataLoad", "noDataMessage", "NoDataComponent", "LoaderWrapperComponent"]);
    react_1["default"].useEffect(function () {
        dispatch({ type: Types.ActionType.RESET });
    }, [props.dataLoad]);
    if (loading) {
        dataLoad
            .then(function (x) {
            dispatch({ type: Types.ActionType.DATALOAD_FULFILLED, payload: x });
        })["catch"](function (err) {
            console.error('Loader', err);
            dispatch({ type: Types.ActionType.DATALOAD_ERROR, payload: err });
        });
        if (LoaderWrapperComponent) {
            return (react_1["default"].createElement(LoaderWrapperComponent, null,
                react_1["default"].createElement(ui_1.Loader, null)));
        }
        return react_1["default"].createElement(ui_1.Loader, null);
    }
    if (!data) {
        if (NoDataComponent) {
            return (react_1["default"].createElement(NoDataComponent, __assign({ error: error }, rest)));
        }
        return react_1["default"].createElement(Typography_1["default"], null, noDataMessage);
    }
    return (react_1["default"].createElement(Component, __assign({ data: data, error: error }, rest)));
};
exports["default"] = WithLoader;
